import React, { useEffect, useState } from "react";
import AdminSidebar from "../components/AdminSidebar";
import AdminNavbar from "../components/AdminNavbar";
import AdminAPI from "../../services/adminApi";
import { toast } from "react-toastify";

function Weather() {
  const [weatherLogs, setWeatherLogs] = useState([]);
  const [analytics, setAnalytics] = useState(null);
  const [farmers, setFarmers] = useState([]);
  const [selectedWeather, setSelectedWeather] = useState(null);

  const [filters, setFilters] = useState({
    search: "",
    date: "",
    condition: ""
  });

  const [weatherForm, setWeatherForm] = useState({
    farmer_id: "",
    temperature: "",
    humidity: "",
    rainfall: "",
    wind_speed: "",
    weather_condition: ""
  });

  useEffect(() => {
    fetchWeatherLogs();
    fetchAnalytics();
    fetchFarmers();
  }, []);

  const fetchWeatherLogs = async () => {
    try {
      const res = await AdminAPI.get(
        `/weather?search=${filters.search}&date=${filters.date}&condition=${filters.condition}`
      );
      setWeatherLogs(res.data);
    } catch (err) {
      console.log(err);
      toast.error("Failed to load weather logs");
    }
  };

  const fetchAnalytics = async () => {
    try {
      const res = await AdminAPI.get(
        "/weather/analytics/summary"
      );
      setAnalytics(res.data);
    } catch (err) {
      console.log(err);
    }
  };

  const fetchFarmers = async () => {
    try {
      const res = await AdminAPI.get("/farmers");
      setFarmers(res.data);
    } catch (err) {
      console.log(err);
    }
  };

  const handleFilterChange = (e) => {
    setFilters({
      ...filters,
      [e.target.name]: e.target.value
    });
  };

  const handleWeatherChange = (e) => {
    setWeatherForm({
      ...weatherForm,
      [e.target.name]: e.target.value
    });
  };

  const createWeather = async (e) => {
    e.preventDefault();

    try {
      await AdminAPI.post("/weather", weatherForm);

      toast.success("Weather log created");

      setWeatherForm({
        farmer_id: "",
        temperature: "",
        humidity: "",
        rainfall: "",
        wind_speed: "",
        weather_condition: ""
      });

      fetchWeatherLogs();
      fetchAnalytics();

    } catch (err) {
      toast.error("Failed to create weather log");
    }
  };

  const openWeather = async (id) => {
    try {
      const res = await AdminAPI.get(`/weather/${id}`);

      setSelectedWeather(res.data);

      setWeatherForm({
        farmer_id: res.data.farmer_id,
        temperature: res.data.temperature || "",
        humidity: res.data.humidity || "",
        rainfall: res.data.rainfall || "",
        wind_speed: res.data.wind_speed || "",
        weather_condition:
          res.data.weather_condition || ""
      });

    } catch {
      toast.error("Failed to load weather log");
    }
  };

  const updateWeather = async () => {
    try {
      await AdminAPI.put(
        `/weather/${selectedWeather.id}`,
        weatherForm
      );

      toast.success("Weather updated");

      setSelectedWeather(null);

      fetchWeatherLogs();
      fetchAnalytics();

    } catch {
      toast.error("Update failed");
    }
  };

  const deleteWeather = async (id) => {
    if (!window.confirm("Delete weather log?")) return;

    try {
      await AdminAPI.delete(`/weather/${id}`);

      toast.success("Weather deleted");

      fetchWeatherLogs();
      fetchAnalytics();

    } catch {
      toast.error("Delete failed");
    }
  };

  return (
    <div className="d-flex">
      <AdminSidebar />

      <div
        style={{
          flex: 1,
          background: "#f5f7fa",
          minHeight: "100vh",
          padding: "20px"
        }}
      >
        <AdminNavbar />

        <h2 className="mt-3">
          🌦 Weather Monitoring
        </h2>

        {/* Analytics */}
        {analytics && (
          <div className="row mt-4 g-3">
            <div className="col-md-2">
              <div className="card shadow border-0">
                <div className="card-body">
                  <h6>Total Logs</h6>
                  <h3>{analytics.total_logs}</h3>
                </div>
              </div>
            </div>

            <div className="col-md-2">
              <div className="card shadow border-0">
                <div className="card-body">
                  <h6>Avg Temp</h6>
                  <h3>{analytics.avg_temperature}</h3>
                </div>
              </div>
            </div>

            <div className="col-md-2">
              <div className="card shadow border-0">
                <div className="card-body">
                  <h6>Avg Humidity</h6>
                  <h3>{analytics.avg_humidity}</h3>
                </div>
              </div>
            </div>

            <div className="col-md-2">
              <div className="card shadow border-0">
                <div className="card-body">
                  <h6>Heat Alerts</h6>
                  <h3>{analytics.heat_alerts}</h3>
                </div>
              </div>
            </div>

            <div className="col-md-2">
              <div className="card shadow border-0">
                <div className="card-body">
                  <h6>Heavy Rain</h6>
                  <h3>{analytics.heavy_rain_alerts}</h3>
                </div>
              </div>
            </div>
          </div>
        )}

        {/* Create */}
        <div className="card shadow border-0 mt-4">
          <div className="card-body">
            <h4>Add Weather Log</h4>

            <form
              onSubmit={createWeather}
              className="row g-3 mt-2"
            >
              <div className="col-md-3">
                <select
                  name="farmer_id"
                  className="form-select"
                  value={weatherForm.farmer_id}
                  onChange={handleWeatherChange}
                  required
                >
                  <option value="">
                    Select Farmer
                  </option>

                  {farmers.map((farmer) => (
                    <option
                      key={farmer.id}
                      value={farmer.id}
                    >
                      {farmer.full_name}
                    </option>
                  ))}
                </select>
              </div>

              <div className="col-md-2">
                <input
                  name="temperature"
                  className="form-control"
                  placeholder="Temp"
                  value={weatherForm.temperature}
                  onChange={handleWeatherChange}
                />
              </div>

              <div className="col-md-2">
                <input
                  name="humidity"
                  className="form-control"
                  placeholder="Humidity"
                  value={weatherForm.humidity}
                  onChange={handleWeatherChange}
                />
              </div>

              <div className="col-md-2">
                <input
                  name="rainfall"
                  className="form-control"
                  placeholder="Rainfall"
                  value={weatherForm.rainfall}
                  onChange={handleWeatherChange}
                />
              </div>

              <div className="col-md-2">
                <input
                  name="wind_speed"
                  className="form-control"
                  placeholder="Wind"
                  value={weatherForm.wind_speed}
                  onChange={handleWeatherChange}
                />
              </div>

              <div className="col-md-3">
                <input
                  name="weather_condition"
                  className="form-control"
                  placeholder="Condition"
                  value={weatherForm.weather_condition}
                  onChange={handleWeatherChange}
                />
              </div>

              <div className="col-md-3">
                <button className="btn btn-success">
                  Add Weather
                </button>
              </div>
            </form>
          </div>
        </div>

        {/* Filters */}
        <div className="card shadow border-0 mt-4">
          <div className="card-body">
            <div className="d-flex gap-3 flex-wrap">
              <input
                type="text"
                name="search"
                className="form-control"
                style={{ width: "220px" }}
                placeholder="Search farmer"
                value={filters.search}
                onChange={handleFilterChange}
              />

              <input
                type="date"
                name="date"
                className="form-control"
                style={{ width: "220px" }}
                value={filters.date}
                onChange={handleFilterChange}
              />

              <input
                type="text"
                name="condition"
                className="form-control"
                style={{ width: "220px" }}
                placeholder="Condition"
                value={filters.condition}
                onChange={handleFilterChange}
              />

              <button
                className="btn btn-success"
                onClick={fetchWeatherLogs}
              >
                Search
              </button>
            </div>
          </div>
        </div>

        {/* Table */}
        <div className="card shadow border-0 mt-4">
          <div className="card-body">
            <div className="table-responsive">
              <table className="table table-bordered table-hover">
                <thead className="table-success">
                  <tr>
                    <th>Farmer</th>
                    <th>Temp</th>
                    <th>Humidity</th>
                    <th>Rainfall</th>
                    <th>Wind</th>
                    <th>Condition</th>
                    <th>Date</th>
                    <th>Actions</th>
                  </tr>
                </thead>

                <tbody>
                  {weatherLogs.map((log) => (
                    <tr key={log.id}>
                      <td>{log.full_name}</td>
                      <td>{log.temperature}</td>
                      <td>{log.humidity}</td>
                      <td>{log.rainfall}</td>
                      <td>{log.wind_speed}</td>
                      <td>{log.weather_condition}</td>
                      <td>{log.logged_at}</td>

                      <td>
                        <button
                          className="btn btn-primary btn-sm me-2"
                          onClick={() => openWeather(log.id)}
                        >
                          Edit
                        </button>

                        <button
                          className="btn btn-danger btn-sm"
                          onClick={() =>
                            deleteWeather(log.id)
                          }
                        >
                          Delete
                        </button>
                      </td>
                    </tr>
                  ))}
                </tbody>

              </table>
            </div>
          </div>
        </div>

        {/* Modal */}
        {selectedWeather && (
          <div
            className="modal d-block"
            style={{
              background: "rgba(0,0,0,0.6)"
            }}
          >
            <div className="modal-dialog">
              <div className="modal-content">

                <div className="modal-header">
                  <h5>Edit Weather</h5>

                  <button
                    className="btn-close"
                    onClick={() =>
                      setSelectedWeather(null)
                    }
                  />
                </div>

                <div className="modal-body">
                  {[
                    "temperature",
                    "humidity",
                    "rainfall",
                    "wind_speed",
                    "weather_condition"
                  ].map((field) => (
                    <input
                      key={field}
                      name={field}
                      className="form-control mb-3"
                      placeholder={field}
                      value={weatherForm[field]}
                      onChange={handleWeatherChange}
                    />
                  ))}
                </div>

                <div className="modal-footer">
                  <button
                    className="btn btn-secondary"
                    onClick={() =>
                      setSelectedWeather(null)
                    }
                  >
                    Close
                  </button>

                  <button
                    className="btn btn-success"
                    onClick={updateWeather}
                  >
                    Save Changes
                  </button>
                </div>

              </div>
            </div>
          </div>
        )}

      </div>
    </div>
  );
}

export default Weather;